export default __webpack_public_path__ + "static/media/GHSI Anti-Corruption Policy.e28e3cd1.pdf";